import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { NavLink } from '../types';
import logoImage from '../assets/airy.webp';
import { colors, typography, borderRadius, layout } from '../styles/designTokens';

const WebsiteTermsPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const navLinks: NavLink[] = [
    { label: 'בית', href: '/', isActive: false },
    { label: 'ממליצים', href: '/#testimonials', isActive: false },
    { label: 'מפרט המכונה', href: '/#product-specs', isActive: false },
    { label: 'נקודות מכירה', href: '/#branches', isActive: false },
    { label: 'צור קשר', href: '/#contact', isActive: false },
  ];

  return (
    <div
      className="min-h-screen scroll-smooth bg-airy-main"
      style={{
        fontFamily: typography.fontFamily,
      }}
    >
      {/* Skip to main content link */}
      <a
        href="#main-content"
        style={{
          position: 'absolute',
          left: '-9999px',
          zIndex: 999,
          padding: '12px 24px',
          backgroundColor: colors.orangeGold,
          color: '#000000',
          fontWeight: 700,
          fontSize: '1rem',
          textDecoration: 'none',
          borderRadius: '4px',
        }}
        onFocus={(e) => {
          e.currentTarget.style.left = '50%';
          e.currentTarget.style.top = '10px';
          e.currentTarget.style.transform = 'translateX(-50%)';
        }}
        onBlur={(e) => {
          e.currentTarget.style.left = '-9999px';
          e.currentTarget.style.top = 'auto';
          e.currentTarget.style.transform = 'none';
        }}
      >
        דלג לתוכן הראשי
      </a>

      <Header
        logoImage={logoImage}
        navLinks={navLinks}
        isMobileMenuOpen={isMobileMenuOpen}
        onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      {/* Main Content */}
      <main id="main-content" className="py-8 md:py-12" style={{ 
        paddingTop: 'clamp(90px, calc(5vw + 70px), 110px)',
        paddingBottom: '40px',
      }}>
        <div className="container mx-auto px-4" style={{ maxWidth: layout.contentMaxWidth }}>
          <div className="max-w-5xl mx-auto">
            {/* Back Button */}
            <div style={{ marginBottom: 'clamp(16px, 2.5vw, 24px)' }}>
              <a
                href="/payment"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: colors.orangeGold,
                  fontSize: 'clamp(0.95rem, 1.8vw, 1.1rem)',
                  fontWeight: 600,
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  padding: '8px 12px',
                  borderRadius: '8px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = colors.gold.mediumLight;
                  e.currentTarget.style.background = 'rgba(245, 182, 88, 0.1)';
                  e.currentTarget.style.transform = 'translateX(4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = colors.orangeGold;
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                <span style={{ fontSize: '1.2em', lineHeight: '1' }}>→</span>
                <span>חזרה לעמוד התשלום</span>
              </a>
            </div>


            
            
            {/* Page Title */}
            <h1 
              className="text-center mb-6 md:mb-8"
              style={{ 
                color: colors.orangeGold,
                fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                fontWeight: 900,
                lineHeight: 1.2,
                letterSpacing: typography.heading.letterSpacing,
                scrollMarginTop: '80px',
              }}
            >
              תקנון ותנאי שימוש באתר
            </h1>
            
            {/* Main Content Box */}
            <div 
              className="p-4 md:p-5 rounded-xl"
              style={{ 
                backgroundColor: '#000000',
                border: '2px solid #FFFFFF',
                borderRadius: borderRadius.soft,
              }}
            >
              {/* Content Sections */}
              <div className="space-y-4 md:space-y-6">
                {/* Section 0 - כללי */}
                <div 
                  className="p-4 md:p-6 rounded-xl"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    border: `1.5px solid ${colors.orangeGold}`,
                    borderRadius: borderRadius.soft,
                  }}
                >
                  <h2 
                    className="mb-4"
                    style={{ 
                      color: colors.orangeGold,
                      fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
                      fontWeight: 900,
                      lineHeight: 1.2,
                    }}
                  >
                    1. כללי וכשירות
                  </h2>
                  <div className="space-y-3">
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      התקנון נכתב בלשון זכר מטעמי נוחות בלבד, אך מתייחס לכל המינים.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      עצם השימוש באתר מהווה הסכמה מלאה לתנאי השימוש המפורטים להלן.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      כל עסקה שתבוצע באתר כפופה להגבלות ולתנאים המפורטים בתקנון זה.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      האתר משמש כפלטפורמת סחר אלקטרוני. כל משתמש מצהיר כי הוא בן 18 ומעלה ובעל כשירות משפטית לביצוע רכישות.
                    </p>
                  </div>
                </div>

                {/* Section 1 - מדיניות משלוחים */}
                <div 
                  className="p-4 md:p-6 rounded-xl"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    border: `1.5px solid ${colors.orangeGold}`,
                    borderRadius: borderRadius.soft,
                  }}
                >
                  <h2 
                    className="mb-4"
                    style={{ 
                      color: colors.orangeGold,
                      fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
                      fontWeight: 900,
                      lineHeight: 1.2,
                    }}
                  >
                    2. מדיניות משלוחים ואספקה
                  </h2>
                  <div className="space-y-3">
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>מועדי אספקה:</strong> מועד האספקה המקסימלי לכל חלקי הארץ הוא בין 7 ל-14 ימי עסקים, הנספרים מהיום שלאחר ביצוע ההזמנה. <br /> אנו עושים מאמץ מרבי לספק את המוצרים מוקדם ככל הניתן, <strong>ובמרבית המקרים המשלוח יגיע בפרק זמן קצר משמעותית.</strong>
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>שירות השילוח:</strong> המשלוחים מבוצעים באמצעות שירות "דואר שליחים" של דואר ישראל המגיע למרבית חלקי הארץ.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>יעדי שילוח:</strong> באחריות הלקוח לוודא כי יישוב המגורים נכלל ברשימת יעדי השירות של דואר ישראל.<br /> במידה והיעד אינו נכלל ברשימת התפוצה של "דואר שליחים", החבילה תישלח לסניף הדואר הקרוב ביותר לבית הלקוח.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>תיאום מסירה:</strong> על פי תקנון חברת השילוח, במידה ובוצעו שתי ניסיונות התקשרות או הגעה ללא מענה מצד הלקוח, השליח רשאי להעביר את החבילה למסירה בסניף הדואר או במרכז המסירה הקרוב לכתובת המגורים, והדבר ייחשב כביצוע מלא של האספקה.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>עיכובים:</strong> מפעיל האתר לא יישא באחריות לעיכובים שאינם בשליטתו הישירה, כגון שביתות או כוח עליון.
                    </p>
                  </div>
                </div>

                {/* Section 2 - ביטולים והחזרות */}
                <div 
                  className="p-4 md:p-6 rounded-xl"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    border: `1.5px solid ${colors.orangeGold}`,
                    borderRadius: borderRadius.soft,
                  }}
                >
                  <h2 
                    className="mb-4"
                    style={{ 
                      color: colors.orangeGold,
                      fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
                      fontWeight: 900,
                      lineHeight: 1.2,
                    }}
                  >
                    3. ביטולים, החזרות והחלפות
                  </h2>
                  <div className="space-y-3">
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>זכות הביטול:</strong> לקוח רשאי לבטל עסקה מיום עשייתה ועד 14 ימים מיום קבלת המוצר או מיום קבלת מסמך פרטי העסקה (המאוחר מביניהם), בהתאם לחוק.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>תנאי החזרה:</strong> החזרת מוצר תתאפשר רק במידה והוא במצב תקין, באריזתו המקורית, ולא נעשה בו כל שימוש. <br /> מוצר שנעשה בו שימוש לא ניתן להחזרה.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>דמי ביטול:</strong> בביטול שלא עקב פגם, ינוכו דמי ביטול בשיעור 5% ממחיר המוצר או 100 ש"ח (לפי הנמוך מביניהם) . <br /> החזרת המוצר תתבצע לאחר תיאום מול שירות הלקוחות בדף צור קשר באמצעות דואר רשום, עלות השילוח תחול על הלקוח.
                    </p>
                  </div>
                </div>

                {/* Section 3 - אחריות */}
                <div 
                  className="p-4 md:p-6 rounded-xl"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    border: `1.5px solid ${colors.orangeGold}`,
                    borderRadius: borderRadius.soft,
                  }}
                >
                  <h2 
                    className="mb-4"
                    style={{ 
                      color: colors.orangeGold,
                      fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
                      fontWeight: 900,
                      lineHeight: 1.2,
                    }}
                  >
                    4. אחריות ובטיחות
                  </h2>
                  <div className="space-y-3">
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>אחריות לשימוש:</strong> המשתמש נושא באחריות מלאה לאופן השימוש במוצר. על המשתמש לפעול בהתאם להוראות היצרן ו/או הוראות הבטיחות המצורפות למוצר; הנהלת האתר לא תישא באחריות לנזק שייגרם כתוצאה משימוש שאינו סביר או שאינו תואם את ההוראות.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>הגבלת אחריות:</strong> אחריות האתר ו/או מפעיליו תהיה מוגבלת בכל מקרה עד לגובה הסכום ששולם בפועל על ידי המשתמש עבור המוצר.<br /> הנהלת האתר לא תהיה אחראית לכל נזק עקיף, תוצאתי או מיוחד מכל סוג שהוא.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      במקרה שנפלה טעות חריגה בתיאור מוצר או במחירו, הנהלת האתר רשאית לבטל את ההזמנה בכפוף להודעה ללקוח והשבת מלוא כספו.
                    </p>
                  </div>
                </div>

                {/* Section 4 - מדיניות פרטיות */}
                <div 
                  className="p-4 md:p-6 rounded-xl"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    border: `1.5px solid ${colors.orangeGold}`,
                    borderRadius: borderRadius.soft,
                  }}
                >
                  <h2 
                    className="mb-4"
                    style={{ 
                      color: colors.orangeGold,
                      fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
                      fontWeight: 900,
                      lineHeight: 1.2,
                    }}
                  >
                    5. מדיניות פרטיות ואבטחת מידע
                  </h2>
                  <div className="space-y-3">
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>איסוף מידע:</strong> בעת רכישה נאספים פרטים (שם, טלפון, דוא"ל וכתובת) לצורך אספקת המוצר.<br /> המידע נשמר במאגר המידע של האתר ולא יועבר לצד ג' למעט חברת השילוח או על פי צו שיפוטי.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>אבטחת סליקה:</strong> האתר מאובטח בפרוטוקול SSL. <br /> פרטי האשראי אינם נשמרים בשרתי האתר אלא מועברים ישירות לספק סליקה מורשה (Grow) בתקן PCI.
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      <strong>Cookies:</strong> האתר עושה שימוש ב-Cookies ובכלי ניתוח לשיפור חווית המשתמש.<br /> המשתמש זכאי לעיין במידע עליו ולבקש את מחיקתו בפנייה למייל: yam0733026674@gmail.com
                    </p>
                    <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                      התמונות באתר נועדו להמחשה בלבד. המידע המתפרסם באתר מהווה המלצה בלבד ואינו תחליף לייעוץ מקצועי.
                    </p>
                  </div>
                </div>

                {/* Section 5 - קניין רוחני */}
                <div 
                  className="p-4 md:p-6 rounded-xl"
                  style={{ 
                    backgroundColor: '#1a1a1a',
                    border: `1.5px solid ${colors.orangeGold}`,
                    borderRadius: borderRadius.soft,
                  }}
                >
                  <h2 
                    className="mb-4"
                    style={{ 
                      color: colors.orangeGold,
                      fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
                      fontWeight: 900,
                      lineHeight: 1.2,
                    }}
                  >
                    6. קניין רוחני
                  </h2>
                  <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight }}>
                    אין להעתיק, לשכפל או להשתמש בתכנים או בתמונות מהאתר ללא אישור בכתב.
                  </p>
                  <p style={{ color: colors.textPrimary, fontSize: typography.fontSize.base, lineHeight: typography.body.lineHeight, marginTop: '1rem', fontStyle: 'italic' }}>
                   <strong> אנו מאחלים לכם הנאה מרובה ממוצרינו.</strong>
                  </p>
                </div>
              </div>

              {/* Contact Section */}
              <div 
                className="mt-8 p-6 md:p-8 rounded-xl text-center"
                style={{ 
                  backgroundColor: '#1a1a1a',
                  border: `1.5px solid ${colors.orangeGold}`,
                  borderRadius: borderRadius.soft,
                }}
              >
                <h2 
                  className="mb-4"
                  style={{ 
                    color: colors.orangeGold,
                    fontSize: 'clamp(1.5rem, 3vw, 2rem)',
                    fontWeight: 900,
                    lineHeight: 1.2,
                  }}
                >
                  צרו קשר
                </h2>
                <p 
                  className="mb-6"
                  style={{ 
                    color: colors.textPrimary,
                    fontSize: 'clamp(0.95rem, 2vw, 1.125rem)',
                    fontWeight: 400,
                    lineHeight: typography.body.lineHeight,
                  }}
                >
                  לשאלות נוספות בנושא תקנון האתר, אנא פנו אלינו
                </p>
                <div className="grid md:grid-cols-2 gap-4 md:gap-6">
                  <div>
                    <h3 
                      className="mb-2"
                      style={{ 
                        color: colors.orangeGold,
                        fontSize: 'clamp(1.125rem, 2vw, 1.25rem)',
                        fontWeight: 700,
                      }}
                    >
                      טלפון
                    </h3>
                    <p 
                      style={{ 
                        color: colors.textPrimary,
                        fontSize: typography.fontSize.lg,
                        fontWeight: 400,
                      }}
                    >
                      073.302.6674
                    </p>
                  </div>
                  <div>
                    <h3 
                      className="mb-2"
                      style={{ 
                        color: colors.orangeGold,
                        fontSize: 'clamp(1.125rem, 2vw, 1.25rem)',
                        fontWeight: 700,
                      }}
                    >
                      דוא"ל
                    </h3>
                    <p 
                      style={{ 
                        color: colors.textPrimary,
                        fontSize: typography.fontSize.lg,
                        fontWeight: 400,
                      }}
                    >
                      yam0733026674@gmail.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default WebsiteTermsPage;
